import { StatsTableContainer } from './stats-table-container';

export { StatsTableContainer };
